import Vue from 'vue'

Vue.mixin({
    computed: {
        canManageReportFields() {
            return this.isCompanyPrimaryUser
                && this.$root.hasAbility('manage-report-fields', 'Billow\\Models\\Company')
        }
    }
})
